import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const CATEGORIES = ["Philosophy", "Spirituality", "Science", "Personal Reflection"];

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 bg-[#FAFAFA]/85 backdrop-blur-md border-b border-black/10"
      data-testid="site-header"
    >
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between gap-6">
        <Link
          to="/"
          className="flex items-baseline gap-3"
          data-testid="brand-link"
        >
          <span className="font-serif text-2xl tracking-tight leading-none">
            Truth
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.28em] text-black/50">
            A Journey
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-[11px] uppercase tracking-[0.22em] font-medium">
          {CATEGORIES.map((c) => (
            <NavLink
              key={c}
              to={`/category/${encodeURIComponent(c)}`}
              className={({ isActive }) =>
                `transition-colors hover:text-black ${
                  isActive ? "text-black" : "text-black/55"
                }`
              }
              data-testid={`nav-category-${c.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {c}
            </NavLink>
          ))}
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `transition-colors hover:text-black ${
                isActive ? "text-black" : "text-black/55"
              }`
            }
            data-testid="nav-about"
          >
            About
          </NavLink>
        </nav>

        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em]">
          {user && user.role === "admin" ? (
            <>
              <Link
                to="/admin"
                className="hover:text-black text-black/70"
                data-testid="header-admin-link"
              >
                Dashboard
              </Link>
              <button
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="hover:text-black text-black/70"
                data-testid="header-logout-btn"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/admin/login"
              className="hover:text-black text-black/55"
              data-testid="header-login-link"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
